import React from "react";
import { useState } from "react";
import axios from "axios";
import { baseurl } from "../../constant";
import Dashcomponent from "../../dashboard/dashcomponent";
const MyProfile = (props) => {
  const token = localStorage.getItem("authToken");
  const [name1, setname1] = useState();
  const [mobile, setmobile] = useState();
  const [email, setemail] = useState();
  const [pmr_token, setpmr_token] = useState();
  const [data, setdata] = useState();
  const [active, setactive] = useState(1);

  const changeProfileData = async () => {
    const result = await axios.post(baseurl + "profileUpdateAuth", {
      token: token,
      name: name1,
      mobile: mobile,
      email: email,
      pmr_token: pmr_token,
    });
    setdata(result.data);
    window.location.reload("/dashboard");
  };

  return (
    <>
      {active == 1 && (
        <div>
          <div className="card shadow ">
            <div className="card-header py-3">
              {data && (
                <h5 style={{ backgroundColor: "green" }}>{data.message}</h5>
              )}
              <div className="row">
                <div className="col-sm-6">
                  <h4>
                    <b>Update Profile</b>
                  </h4>
                </div>

                {/* <div className="col-sm-6  text-right">
                  <button
                    className="btn btn-primary"
                    onClick={() => setactive(2)}
                  >
                    <i className="fa fa-arrow-left"> Back</i>
                  </button>
                </div> */}
              </div>
            </div>
            <div className="card-body">
              <form
                id="admin_profile"
                enctype="multipart/form-data"
                method="post"
                accept-charset="utf-8"
              />
              <input type="hidden" name="method" value="post" />
              <input type="hidden" value="https://www.payol.in/" id="siteUrl" />
              <div className="row">
                <div className="col-sm-3">
                  <div className="form-group">
                    <label>
                      <b>Name*</b>
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      name="name"
                      id="name"
                      placeholder={props.name}
                      value={name1}
                      onChange={(e) => setname1(e.target.value)}
                    />
                  </div>
                </div>

                <div className="col-sm-3">
                  <div className="form-group">
                    <label>
                      <b>Email</b>
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      name="email"
                      id="email"
                      placeholder={props.email}
                      value={email}
                      onChange={(e) => setemail(e.target.value)}
                    />
                  </div>
                </div>

                <div className="col-sm-3">
                  <div className="form-group">
                    <label>
                      <b>Mobile*</b>
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      name="mobile"
                      id="mobile"
                      placeholder={props.mobile}
                      value={mobile}
                      onChange={(e) => setmobile(e.target.value)}
                    />
                  </div>
                </div>

                <div className="col-sm-3">
                  <div className="form-group">
                    <label>
                      <b>PMR Token</b>
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      name="pmr_token"
                      id="pmr_token"
                      placeholder={props.pmrToken}
                      value={pmr_token}
                      onChange={(e) => setpmr_token(e.target.value)}
                    />
                  </div>
                </div>
              </div>
              <div className="card shadow">
                <div className="card-header py-3 text-right">
                  <button
                    type="submit"
                    className="btn btn-success"
                    onClick={changeProfileData}
                  >
                    Submit
                  </button>
                  {/* <button type="button" className="btn btn-secondary">
                    Cancel
                  </button> */}
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* {active == 2 && (
        <div>
          {" "}
          <Dashcomponent />
        </div>
      )} */}
    </>
  );
};

export default MyProfile;
